"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configure = configure;
var _api = require("../api/api");
var _nreum = require("../../common/window/nreum");
var _info = require("../../common/config/info");
var _init = require("../../common/config/init");
var _loaderConfig = require("../../common/config/loader-config");
var _runtime = require("../../common/config/runtime");
var _featureFlags = require("../../common/util/feature-flags");
var _runtime2 = require("../../common/constants/runtime");
var _publicPath = require("./public-path");
var _contextualEe = require("../../common/event-emitter/contextual-ee");
let alreadySetOnce = false; // the configure() function can run multiple times in agent lifecycle

/**
 * Sets or re-sets the agent's configuration values from global settings. This also attach those as properties to the agent instance.
 */
function configure(agent, opts = {}, loaderType, forceDrain) {
  // eslint-disable-next-line camelcase
  let {
    init,
    info,
    loader_config,
    runtime = {},
    exposed = true
  } = opts;
  runtime.loaderType = loaderType;
  const nr = (0, _nreum.gosCDN)();
  if (!info) {
    init = nr.init;
    info = nr.info;
    // eslint-disable-next-line camelcase
    loader_config = nr.loader_config;
  }
  (0, _init.setConfiguration)(agent.agentIdentifier, init || {});
  // eslint-disable-next-line camelcase
  (0, _loaderConfig.setLoaderConfig)(agent.agentIdentifier, loader_config || {});
  info.jsAttributes ??= {};
  if (_runtime2.isWorkerScope) {
    // add a default attr to all worker payloads
    info.jsAttributes.isWorker = true;
  }
  (0, _info.setInfo)(agent.agentIdentifier, info);
  const updatedInit = (0, _init.getConfiguration)(agent.agentIdentifier);
  const internalTrafficList = [info.beacon, info.errorBeacon];
  if (!alreadySetOnce) {
    if (updatedInit.proxy.assets) {
      (0, _publicPath.redefinePublicPath)(updatedInit.proxy.assets);
      internalTrafficList.push(updatedInit.proxy.assets);
    }
    if (updatedInit.proxy.beacon) internalTrafficList.push(updatedInit.proxy.beacon);
    (0, _api.setTopLevelCallers)(); // no need to set global APIs on newrelic obj more than once
    (0, _nreum.addToNREUM)('activatedFeatures', _featureFlags.activatedFeatures);

    // Update if soft_navigations is allowed to run AND part of this agent build, used to override old spa functions.
    agent.runSoftNavOverSpa &&= updatedInit.soft_navigations.enabled === true && updatedInit.feature_flags.includes('soft_nav');
  }
  runtime.denyList = [...(updatedInit.ajax.deny_list || []), ...(updatedInit.ajax.block_internal ? internalTrafficList : [])];
  runtime.ptid = agent.agentIdentifier;
  (0, _runtime.setRuntime)(agent.agentIdentifier, runtime);
  agent.ee = _contextualEe.ee.get(agent.agentIdentifier);
  if (agent.api === undefined) agent.api = (0, _api.setAPI)(agent.agentIdentifier, forceDrain, agent.runSoftNavOverSpa);
  if (agent.exposed === undefined) agent.exposed = exposed;
  alreadySetOnce = true;
}